import { render } from "./skeletonDetail.vue?vue&type=template&id=35483130"
import script from "./skeletonDetail.vue?vue&type=script&lang=js"
export * from "./skeletonDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__